import React from 'react';
import { useNavigate } from 'react-router-dom';

function CheckEmail() {
  const navigate = useNavigate();

  const handleResendEmail = () => {
    navigate('/resend-confirmation-email');
  };

  return (
    <div className="seller-await-confirmation-page">
      <div className="seller-await-confirmation-container">
        {/* Header con icona */}
        <div className="seller-await-confirmation-header">
          <div className="seller-await-confirmation-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 className="seller-await-confirmation-title">Controlla la tua email</h2>
          <p className="seller-await-confirmation-subtitle">Abbiamo inviato un link di conferma</p>
        </div>

        {/* Contenuto principale */}
        <div className="seller-await-confirmation-content">
          <div className="seller-await-confirmation-message">
            <svg className="seller-await-confirmation-message-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <p>Ti abbiamo inviato un'email di conferma. Controlla la tua casella di posta elettronica e segui il link per attivare il tuo account venditore.</p>
          </div>

          <div className="seller-await-confirmation-info">
            <svg className="seller-await-confirmation-info-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="m9 12 2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <p>Se non hai ricevuto l'email, clicca il pulsante qui sotto per inviarla nuovamente.</p>
          </div>

          <button className="seller-await-confirmation-btn" onClick={handleResendEmail}>
            <svg className="seller-await-confirmation-btn-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M21 3v5h-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M3 21v-5h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Invia nuovamente l'email di conferma</span>
          </button>
        </div>

        {/* Footer con progresso */}
        <div className="seller-await-confirmation-footer">
          <div className="seller-await-confirmation-steps">
            <div className="seller-await-confirmation-step completed">
              <div className="seller-await-confirmation-step-number">1</div>
              <span>Registrazione</span>
            </div>
            <div className="seller-await-confirmation-step-arrow">→</div>
            <div className="seller-await-confirmation-step active">
              <div className="seller-await-confirmation-step-number">2</div>
              <span>Verifica</span>
            </div>
            <div className="seller-await-confirmation-step-arrow">→</div>
            <div className="seller-await-confirmation-step">
              <div className="seller-await-confirmation-step-number">3</div>
              <span>Completa il Profilo Aziendale</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckEmail;
